angular.module('storefrontApp')
    .controller('productCardController', ['$scope', function ($scope) {
        $scope.colorsLoaded = [];
        $scope.colors = [];
        $scope.filters = {
            currentColor: '',
        };
    }]);
